<template>
  <div class="parallax-section" ref="parallax">
    <div class="parallax-section__wrapper">
      <img class="parallax__rectangle" :src="require('assets/images/landing/rectangle.svg')" alt="Figura">
      <img class="parallax__combined-shape" :src="require('assets/images/landing/combined-shape.svg')" alt="Figura">
      <img class="parallax__blue-oval" :src="require('assets/images/landing/blue-oval.svg')" alt="Figura">
      <img class="parallax__yellow-line" :src="require('assets/images/landing/yellow-line.svg')" alt="Figura">
      <img class="parallax__rectangle-bottom" :src="require('assets/images/landing/rectangle.svg')" alt="Figura">
      <img class="parallax__green-oval" :src="require('assets/images/landing/green-oval.svg')" alt="Figura">
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    window.addEventListener('scroll', this.moveParallax);
  },
  destroyed() {
    window.removeEventListener('scroll', this.moveParallax);
  },
  methods: {
    moveParallax() {
      this.$refs.parallax.style.transform = `translate3D(0, -${window.pageYOffset * 0.5}px, 0)`;
    },
  },
};
</script>

<style lang="scss" scoped>
.parallax-section {
  height: 683px;
  position: fixed;
  top: 500px;
  width: 100%;

  @media screen and (max-width: $screen-md-max) {
    top: 350px;
  }
}

.parallax-section__wrapper {
  position: relative;
}

.parallax__rectangle {
  height: 38px;
  left: 85%;
  position: absolute;
  width: auto;
}

.parallax__combined-shape {
  height: 142px;
  left: 86%;
  position: absolute;
  top: 264px;
  width: auto;
}

.parallax__blue-oval {
  height: 113px;
  left: 0;
  position: absolute;
  top: 240px;
  width: auto;
}

.parallax__yellow-line {
  height: 14px;
  left: 10%;
  position: absolute;
  top: 294px;
  width: auto;
}

.parallax__rectangle-bottom {
  height: 38px;
  left: 25.5%;
  position: absolute;
  top: 378px;
  width: auto;
}

.parallax__green-oval {
  height: 200px;
  left: 0%;
  position: absolute;
  top: 511px;
  width: auto;
}
</style>
